// Yetki kontrolü yardımcı fonksiyonları

export const hasPermission = (userProfile, permissionName) => {
  if (!userProfile || !userProfile.role) return false

  // Super admin her şeyi yapabilir
  if (userProfile.role.name === 'super_admin') return true

  // Rol izinlerini kontrol et
  // Not: Bu basit bir kontrol, gerçek uygulamada role_permissions tablosundan çekilmeli
  const rolePermissions = {
    admin: [
      'users.create',
      'users.update',
      'users.delete',
      'schools.create',
      'schools.update',
      'schools.delete',
      'notifications.create',
      'notifications.view',
    ],
    mudur: ['notifications.view', 'notifications.update_status'],
    ogretmen: ['notifications.view'],
  }

  const permissions = rolePermissions[userProfile.role.name] || []
  return permissions.includes(permissionName)
}

export const hasRole = (userProfile, roleName) => {
  if (!userProfile || !userProfile.role) return false
  return userProfile.role.name === roleName
}

export const hasAnyRole = (userProfile, roleNames) => {
  if (!userProfile || !userProfile.role) return false
  return roleNames.includes(userProfile.role.name)
}




